import React, { FC, ReactNode }         from 'react';
import { Cell, Grid }                   from "styled-css-grid";
import { Header, List }                 from 'semantic-ui-react';
import { StyledContainer }              from './StyledContainer';
import { CategoryDescTooltip, Tooltip } from '../components/util/messaging/ToolTip';
import { Link }                         from 'react-router-dom';

interface Props {
	
	/* Title header */
	title?: string | ReactNode,
	
	/* Title tooltip */
	titleTooltip?: ReactNode,
	
	/* Title size */
	titleSize?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6',
	
	/* Descriptive text that appears under title */
	desc?: string,
	
	isLoading?: boolean,
	
	links?: Array<{ route: string, label: string }>
	
	headerLinkGap?: number,
}

const defaultProps: Props = {
	headerLinkGap: 100,
	titleSize:     'h1'
}

const ContentHeaderWithLinks: FC<Props> = ( props ) => {
	
	let hasLinks = props.links?.length ?? false;
	
	return (
		
		<Grid columns={ `1fr auto` } columnGap={ `${ props.headerLinkGap }px` }>
			
			{/* Header / Description */ }
			{ ( props.title || props.desc ) && (
				<Cell>
					
					{ props.title && (
						<Header as={ 'h1' }>
							{ props.isLoading ? 'Loading...' : props.title }
							{ ( !props.isLoading && props.titleTooltip ) && (
								<StyledContainer className={ 'display--inline-block text--md' }>
									{ props.titleTooltip }
								</StyledContainer>
							) }
						</Header>
					) }
					{ props.desc && <p>{ props.desc }</p> }
				
				</Cell>
			) }
			
			{/* Nav Links */ }
			<Cell className={ 'padding-sm-top' }>
				
				{ hasLinks && (
					
					<List horizontal divided>
						
						
						{ props.links.map( item => {
							
							return <List.Item><Link to={ item.route }>{ item.label }</Link></List.Item>;
							
						} ) }
					</List>
				
				) }
			
			</Cell>
		
		</Grid>
	);
};

ContentHeaderWithLinks.defaultProps = defaultProps;

export { ContentHeaderWithLinks }
